module.exports = __webpack_public_path__ + "img/jake-di-pietro.dd7ab9b5.png";